// this function has been pulled from this blogpost that came up with
// a solve for the lack of onLoad method for Intercom
// https://fokkezb.nl/2016/04/14/how-to-wait-for-a-javascript-variable-to-be-defined/

declare global {
    interface Window {
        intercomSettings: string;
    }
}

export default function afterIntercomHasLoaded(callback: () => void) {
    if (window.intercomSettings) {
        callback();
        return;
    } else {
        Object.defineProperty(window, 'intercomSettings', {
            configurable: true,
            enumerable: true,
            get: function () {
                return this._intercomSettings;
            },
            set: function (val) {
                this._intercomSettings = val;
                callback();
            },
        });
    }
}
